import useMeasure from 'react-use-measure'
import { HoverIcon } from '../_icons/HoverIcon'
import styles from './TextOverflow.module.scss'

interface TextOverflowProps {
    text?: string
    font?: string
    maxWidth: number
    bubbleMinWidth?: number
    growLeft?: boolean
}

export const TextOverflow = (props: TextOverflowProps) => {
    let { text = '', font, maxWidth, bubbleMinWidth = 200, growLeft = false } = props
    font = font || getComputedStyle(document.body).font
    const [ref, bounds] = useMeasure()
    const getTextWidth = (text: string, font: string) => {
        // re-use canvas object for better performance
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')!
        context.font = font
        const metrics = context.measureText(text)
        return metrics.width
    }

    let overflows = bounds.width < getTextWidth(text.replace(/\s+/g, ' ').trim(), font) - 5
    return (
        <div ref={ref} style={{ maxWidth }}>
            {overflows ? (
                <HoverIcon
                    growDown={true}
                    growLeft={growLeft}
                    // offset={bounds.width}
                    renderIcon={() => (
                        <div>
                            <div
                                style={{
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {text}
                            </div>
                        </div>
                    )}
                    style={{ display: 'block' }}
                >
                    {(closeBubble: () => void) => (
                        <div
                            className={styles.leadTimeBubble}
                            style={{
                                textAlign: 'left',
                                padding: '14px 19px',
                                minWidth: bubbleMinWidth,
                                maxWidth: 250,
                                overflowWrap: 'anywhere',
                                whiteSpace: 'initial',
                            }}
                            onClick={(e: any) => e.stopPropagation()}
                        >
                            {text}
                        </div>
                    )}
                </HoverIcon>
            ) : (
                <div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>{text}</div>
            )}
        </div>
    )
}
